<template>
	<div class="autocomplete-text">
		<input type="text" class="input"
		:id="passedId"
		@blur="passedMethod"
		></input>

	</div>
</template>

<script>
export default {
	props: {
		passedId: null,
		availableOptions: null,
		passedMethod: null,
	},

	data () {
		return {
			
		}
	},

	mounted () {
		//console.log(this.availableOptions);
		var vThis = this;
		
		$('#' + vThis.passedId).autocomplete({
	      	source: vThis.availableOptions
	    });
	},

	methods: {
		
	}

}
</script>

<style scoped>

</style>